import React, { useState, useEffect } from "react";
import "./Exercise.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import ProgramBanner from "../../Components/ProgramBanner/ProgramBanner";
import ExerciseFAQ from "./ExerciseFAQ";
import FAQ from "../../Components/FAQ/FAQ";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import Loading from "../../Components/Loading/Loading";
import { useBaseUrl } from "../../ApiContext";

export default function Exercise() {
  const location = useLocation();
  const baseUrl = useBaseUrl()
  const label = location.state?.label;
  const title = location.state?.title;
  const { userToken } = useAuth();
  const [exerciseCourses, setExerciseCourses] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchExercisePlanList = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/exercise_plan_list/${label.toUpperCase()}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        console.log(response.data);
        setExerciseCourses(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log("Error during getting exercise plan list", error);
      }
    };
    if (userToken) {
      fetchExercisePlanList();
    }
  }, [baseUrl, userToken]);

  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="pageTitle horizontalBorder">{title}</div>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="exerciseContent scroll responsiveWidth centeredFlex">
              <div className="exerciseBanners horizontalBorder">
                {exerciseCourses.advanced !== null && (
                  <ProgramBanner
                    label="exercise"
                    {...exerciseCourses.advanced}
                  />
                )}
                {exerciseCourses.beginner !== null && (
                  <ProgramBanner
                    label="exercise"
                    {...exerciseCourses.beginner}
                  />
                )}
              </div>
              <div className="exerciseFAQWrapper">
                {ExerciseFAQ.map((faq) => (
                  <FAQ
                    key={faq.id}
                    question={faq.question}
                    answer={faq.answer}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
